"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TYPE = {
  PREFIX: 'prefix',
  SUFFIX: 'suffix',
  ADDON_BEFORE: 'addonBefore',
  ADDON_AFTER: 'addonAfter'
};
/**
 * This is an internal private helper component to be used along with
 * TextInput.  Input uses this along with TextInput to build out various
 * addon styles.
 */

var InputAddon =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InputAddon, _React$Component);

  function InputAddon() {
    _classCallCheck(this, InputAddon);

    return _possibleConstructorReturn(this, _getPrototypeOf(InputAddon).apply(this, arguments));
  }

  _createClass(InputAddon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          type = _this$props.type,
          appearance = _this$props.appearance,
          focus = _this$props.focus,
          error = _this$props.error,
          disabled = _this$props.disabled,
          props = _objectWithoutProperties(_this$props, ["className", "type", "appearance", "focus", "error", "disabled"]);

      var styleProps = {
        'data-disabled': disabled,
        'data-error': error,
        'data-focus': focus,
        'data-border-type': appearance,
        'data-type': type
      };
      return _react.default.createElement(_FlexLayout.default, _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-input-addon")),
        alignItems: "center",
        display: "inline-flex"
      }, styleProps, props));
    }
  }]);

  return InputAddon;
}(_react.default.Component);

exports.default = InputAddon;
InputAddon.TYPE = TYPE;
InputAddon.defaultProps = {
  type: TYPE.SUFFIX,
  appearance: 'normal',
  focus: false,
  error: false,
  disabled: false
};
InputAddon.propTypes = {
  /**
   * Customize class name.
   */
  className: _propTypes.default.string,

  /**
   * Various types of add on for input.
   */
  type: _propTypes.default.oneOf([TYPE.PREFIX, TYPE.SUFFIX, TYPE.ADDON_BEFORE, TYPE.ADDON_AFTER]),

  /**
   * Input appearance style
   * 'inline' - Input is inline and nested with no borders or background.
   * 'normal' - border with focus highlight
   * 'borderless' - no border with focus highlight.  Normally used on darker contrasted background.
   * 'nested' - no border with no focus highlight.
   *    Useful around situation where you need input inside another component.
   *    For example input inside a table cell.
   */
  appearance: _propTypes.default.oneOf(['inline', 'normal', 'borderless', 'nested']),

  /**
   * error style
   */
  error: _propTypes.default.bool,

  /**
   * disabled style
   */
  disabled: _propTypes.default.bool,

  /**
   * Focus style
   */
  focus: _propTypes.default.bool
};